import React from 'react';
import { useTranslation } from 'react-i18next';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { Table } from '@components/atoms/Table';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { ActiveDriver } from '@services/useGetActiveDrivers';
import { useLogUserCall } from '@services/useLogUserCall';

export function ActiveDriversTable({ drivers }: { drivers: ActiveDriver[] }) {
    const { t } = useTranslation();
    const { request: logEvent } = useLogUserCall();

    return (
        <>
                {drivers.length === 0 ? (
                    <Typography color="muted">{t('active-drivers.empty')}</Typography>
                ) : (
                    <Table
                        compressedSize
                        headerCols={[
                            { classes: 'text-start', text: t('active-drivers.name') },
                            { classes: 'text-start', text: t('active-drivers.phone') },
                        ]}
                        contentRows={drivers.map((driver) => [
                            { content: <Typography fontWeight="700">{driver.name}</Typography> },
                            {
                                content: driver.phone_number ? (
                                    <Anchor
                                        tel={driver.phone_number.replace(/[^+\d]/g, '')}
                                        mode={AnchorMode.none}
                                        onClick={() => {
                                            logEvent({
                                                event_type_name: 'Chamada telefónica iniciada',
                                                action: 'ligou para ' + driver.name,
                                                to_uuid: driver.uuid,
                                            });
                                        }}>
                                        <Typography tagVariant={TypographyTagVariants.span}>
                                            {driver.phone_number}
                                        </Typography>
                                    </Anchor>
                                ) : <Typography color="muted">—</Typography>,
                            },
                        ])}
                    />
                )}
        </>
    );
}
